/* @flow */
import Entity from 'lib/Entity';

export type ReactionUser = {
  name: string,
  uuid: string,
}

export default class Reaction extends Entity {

  getName(): string {
    return this.get('name');
  }

  getEmojiCode(): string {
    return `:${this.get('name')}:`; // API returns Emoji shortcodes with no colons
  }

  getUsers(): Array<ReactionUser> {
    return this.get('users');
  }

  getUserNames(): Array<string> {
    return this.get('users').map(user => user['name']);
  }

  getUserUuids(): Array<string> {
    return this.get('users').map(user => user['uuid']);
  }

  getCount(): number {
    return this.get('count');
  }
}



// WEBPACK FOOTER //
// ./src/entities/Reaction.js